const state = () => ({
    showModalEmailPhone: true,
    showModalDemographic: true,
    user: null,
    isOver65: false,
})

const getters = {
    isAuthenticated: state => !!state.user,
    canViewTaxForm: state => state.user && state.user.canViewTaxForm,
    canViewMyBenefits: state => state.user && state.user.wellthfeatures && state.user.wellthfeatures.my_benefits,
    canViewMyHealth: state => state.user && state.user.wellthfeatures &&
        (state.user.wellthfeatures.my_health ||
            state.user.wellthfeatures.personal_health_record ||
            state.user.wellthfeatures.i_need_care ||
            state.user.wellthfeatures.emergency_contacts) &&
        state.user.speciality === 'N',
    isOver65: state => state.isOver65,
}

const actions = {
    emailPhoneModalOff({ commit }) {
        commit('emailPhoneModalOff')
    },
    demographicModalOff({ commit }) {
        commit('demographicModalOff')
    },
    setUser({ commit }, user) {
        commit('setUser', user);
    },
    async logout({ commit, rootState }) {
        try {
            await fetch(rootState.navigation.routes.logout, { method: 'POST' });
            commit('setUser', null);
            window.location.reload();
        } catch (error) {
            console.error('Logout failed', error);
        }
    },
}

const mutations = {
    emailPhoneModalOff(state) {
        state.showModalEmailPhone = false;
    },
    demographicModalOff(state) {
        state.showModalDemographic = false;
    },
    setUser(state, user) {
        state.user = user;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
